export default __webpack_public_path__ + "static/media/Ascension_to_Aiur_LE.89a5ca97.jpg";